import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { map, tap, withLatestFrom } from 'rxjs';
import { PagePath } from '../enums/page-path.enum';
import { GuardsContextService } from '../services/guards-context.service';
import { NavigationService } from '../services/navigation.service';
import { PlansStateService } from '../services/plans-state.service';

export const availablePlansGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  guardsContextService = inject(GuardsContextService),
  plansStateService = inject(PlansStateService),
  navigationService = inject(NavigationService)
) => {
  return guardsContextService.getIsProcessingAuth$().pipe(
    withLatestFrom(plansStateService.hasPlans$()),
    tap(([isProcessingAuth, hasPlans]) => {
      if (!isProcessingAuth && !hasPlans) {
        navigationService.navigateToPagePath([PagePath.HOME]);
      }
    }),
    map(([isProcessingAuth, hasPlans]) => isProcessingAuth || hasPlans)
  );
};
